// Libraries
import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'

// Components
import SessionExpiration from 'components/Shell/SessionExpiration/index'
import Header from 'components/Shell/Header'
import LeftMenu from 'components/Shell/LeftMenu/LeftMenu'
import MainContent from 'components/Shell/MainContent/MainContent'
import Footer from 'components/Shell/Footer/Footer'
import WelcomeTour from 'components/WelcomeTour'
import SecureRoute from 'components/security/SecureRoute'
import HomePage from 'components/HomePage'
import MicroFrontendLoader from 'components/MicroFrontendLoader'
import Notifications from 'components/Notifications'
import Regulations from 'components/Regulations'
// import MutualWorld from 'components/MutualWorld'
import FrequentQuestions from 'components/FrequentQuestions'
import Subdomain from 'components/SecurityAdministration/Subdomains'
import Application from 'components/SecurityAdministration/Applications'
import Bucket from 'components/SecurityAdministration/Bucket'
import Module from 'components/SecurityAdministration/Modules'
import Functionality from 'components/SecurityAdministration/Functionalities'
import Operation from 'components/SecurityAdministration/Operations'
import User from 'components/SecurityAdministration/Users'
import UserInternalDashboard from 'components/SecurityAdministration/UsersInternal'
import Role from 'components/SecurityAdministration/Roles/Role' // TODO: refactor
import RoleSearch from 'components/SecurityAdministration/Roles/RoleSearch' // TODO: refactor
import LinkRoleToOperation from 'components/SecurityAdministration/Roles/LinkRoleToOperation'
import Group from 'components/SecurityAdministration/Groups'
import GroupToRolesAndUsers from 'components/SecurityAdministration/Groups/GroupToRolesAndUsers'
import BulkImportUsers from 'components/SecurityAdministration/Tools/BulkImportUsers'
import RoleExport from 'components/SecurityAdministration/Roles/RoleExport'
import RoleImport from 'components/SecurityAdministration/Roles/RoleImport'
import ResponseQuestionnaire from 'components/ResponseQuestionnaire'
// src\components\MutualWorld\components\ReporterModal\DataWareHouse
// styles:
import useMainDashboardStyles from './styles'
import CreateInitalQuestionnaire from 'components/Questionnaire/CreateInitalQuestionnaire'

const MainDashboard = () => {
   const classes = useMainDashboardStyles()

   const { path } = useRouteMatch()

   return (
      <div className={classes.root}>
         <SessionExpiration />
         <WelcomeTour />
         <Header />
         <LeftMenu />
         <MainContent>
            <div id="pageContainer" className={classes.content}>
               <Switch>
                  <SecureRoute exact path={`${path}`} component={HomePage} />
                  <SecureRoute
                     exact
                     path={`${path}/applications/:appName/:operation?/:origin?`}
                     component={MicroFrontendLoader}
                  />
                  <SecureRoute exact path={`${path}/notifications`} component={Notifications} />
                  <SecureRoute exact path={`${path}/mutual-world`} component={HomePage} />
                  <SecureRoute
                     exact
                     path={`${path}/mutual-world/response-questionary`}
                     component={ResponseQuestionnaire}
                  />
                  <SecureRoute exact path={`${path}/security/REGISTRAR-PREGUNTAS`} component={FrequentQuestions} />
                  <SecureRoute exact path={`${path}/gestionar-infraestructura/CREAR-BUCKETS`} component={Bucket} />
                  <SecureRoute exact path={`${path}/mutual-world/cuestionario`} component={CreateInitalQuestionnaire} />
                  <SecureRoute exact path={`${path}/regulations`} component={Regulations} />
                  <SecureRoute exact path={`${path}/security/domain/register`} component={Subdomain} />
                  <SecureRoute exact path={`${path}/security/domain/search`} component={Subdomain} isSearch />
                  <SecureRoute exact path={`${path}/security/application/register`} component={Application} />
                  <SecureRoute exact path={`${path}/security/application/search`} component={Application} isSearch />
                  <SecureRoute exact path={`${path}/security/module/register`} component={Module} />
                  <SecureRoute exact path={`${path}/security/module/search`} component={Module} isSearch />
                  <SecureRoute exact path={`${path}/security/functionality/register`} component={Functionality} />
                  <SecureRoute
                     exact
                     path={`${path}/security/functionality/search`}
                     component={Functionality}
                     isSearch
                  />
                  <SecureRoute exact path={`${path}/security/operation/register`} component={Operation} />
                  <SecureRoute exact path={`${path}/security/operation/search`} component={Operation} isSearch />
                  <SecureRoute exact path={`${path}/security/role/register`} component={Role} />
                  <SecureRoute exact path={`${path}/security/role/search`} component={RoleSearch} />
                  <SecureRoute exact path={`${path}/security/role/operation`} component={LinkRoleToOperation} />
                  <SecureRoute exact path={`${path}/security/role/import`} component={RoleImport} />
                  <SecureRoute exact path={`${path}/security/role/export`} component={RoleExport} />
                  <SecureRoute exact path={`${path}/security/user/register`} component={User} />
                  <SecureRoute exact path={`${path}/security/user/search`} component={User} isSearch />
                  <SecureRoute
                     exact
                     path={`${path}/security/registrar-usuario-interno`}
                     component={UserInternalDashboard}
                     isSearch
                  />
                  <SecureRoute exact path={`${path}/security/group/register`} component={Group} />
                  <SecureRoute exact path={`${path}/security/group/search`} component={Group} isSearch />
                  <SecureRoute exact path={`${path}/security/group/roles-and-users`} component={GroupToRolesAndUsers} />
                  <SecureRoute exact path={`${path}/security/tools/bulk-users`} component={BulkImportUsers} />
               </Switch>
            </div>
            <Footer />
         </MainContent>
      </div>
   )
}

export default MainDashboard
